const routes = {
  UpdateCertificate: '/customers/certificates/update',
  CreateCertificate: '/customers/certificates/add',
  getCandidateLists: '/customers/candidates',
  getCertificates: '/customers/certificates',
  ServiceInvoiceDetail: '/services/invoices/details',
  UpdateAddOnservice: '/customers/services/update',
  getInvoices: '/customers/services',
  CreateAddOnService: '/customers/services/add',
  requestBuyerId: 'customers/requestBuyerId',
  requestBuyerIdAgain: 'customers/requestBuyerIdAgain',
  getCustomerDropDown: 'customers/dropdown',
  getCustomerQueue: '/customers',
  getCustomerDetail: 'customers/details',
  getBuyerIdDetail: 'customers/buyerId/details',
  getBuyerIdByAuctionId: 'customers/request/details',
  verifyFinance: 'customers/verifyFinance',
  allocateBuyerId: 'customers/allocateBuyerId',
  deallocateBuyerId: 'customers/deallocateBuyerId',
  changeAllocationStatus: 'customers/changeAllocationStatus',
  getMessages: 'customers/messages',
  sendMessage: 'customers/sendMessage',
  getCustomerBooking: 'customers/booking',
  getCustomerBuyerId: 'customers/buyerIds',
  deleteId: 'customers/removeAuctionHouse',
  getGalaxyCustomerList: 'customers/galaxy',
  CreateMemo: 'customers/sendMemo',
  CreateNotifcation: 'customers/sendNotifications',
  ChangeBranch: 'customers/updateBranch',
  ChangeType: 'customers/updateTrustedStatus',
  CreateSubCustomer: 'users/addSubCustomer',
  getSubCustomerList: 'users/subCustomers',
  SelectCustomer: 'vehicleBookings/update',
  getAgents: '/agents',
  addCustomer: '/customers/add',
  UpdateCustomer: 'customers/update',
  AddVisa: '/visas/addRequest',
  VisaProcessing: '/visas/processing',
  getWPSList: '/customers/wps',
  UpdateWPStatus: '/customers/wps/update',
  CreateWPS: '/customers/wps/add',
  UpdateAddOnService: '/customers/services/update',
  getCandidateDetail: '/customers/candidates/details',
  CustomerStatus: 'customers/updateStatus',
  DeleteVoucher: 'accounts/journalVouchers/delete',
  checkWPS: '/customers/wps/check',
  getRejectedVisa: 'customers/candidates/rejected',
  UpdateCandidate: 'customers/candidates/update',
  handleDeleteDraft: 'visas/deleteDraft',
  checkPassportNumber: 'customers/candidates/checkPassport',
  getCustomerAdvances: 'payments/advances',
  CreateCustomerAdvance: 'payments/advances/add',
  deleteCustomerAdvance: 'payments/advances/delete',
  getAccountBalance: '/accounts/balance',
  getCombinedReport: '/reports/customerCombinedReport',
  getCompanyPayroll: '/reports/customerSalaryReport',
  getVoidVisas: 'visas/voided',
  restrictCandidates: 'customers/restrictedCandidates/add',
  getRestrictedCandidates: 'customers/restrictedCandidates',
  submitCharges: 'customers/monthlyCharges/update',
  getCharges: 'customers/monthlyCharges',
  CreateBank: '/system/banks/add',
  getBanks: '/system/banks',
  DeleteBank: '/system/banks/delete',
  UpdateBank: '/system/banks/update',
  getBankDetail: '/system/banks/details',
  CreateCard: '/system/cards/add',
  getCards: '/system/cards/',
  UpdateCard: '/system/cards/update',
  getCategoryList: '/services/categories',
  CreateCategory: '/services/categories/add',
  getServiceItem: "/services",
  AddServiceItem: "/services/add",
  UpdateServiceItem: "/services/update",
  DeleteServiceItem: "/services/delete",
  ServiceItemDetail: "/services/details",
  getCategoryDetail: '/services/categories/details',
  UpdateCategory: '/services/categories/update',
  DeleteCategory: '',
  CreateCustomerPayment: 'payments/customer/add',
  customerPaymentUpdate: 'payments/customer/update',
  DeleteCustomerPayment:'payments/customer/delete',
  CreateServiceItem:'services/add',
  CreateServiceInvoice:'services/invoices/add',
  getServiceInvoices:'services/invoices'
};

export default routes